export default __webpack_public_path__ + "static/media/wfdsa.dcfbc9cd.svg";